import { ReactNode } from "react";
import { XSquare } from 'react-bootstrap-icons';

interface ModalProps {
    title: string;
    children: ReactNode | undefined;
    closeclick:()=>void
  }

  //Questo componente mostra una finestra modate nella pagina web
  export const PopUp: React.FC<ModalProps> = ({
    title,
    children,
    closeclick}) => {
    return(
      <div
        className="modal App-modal fade show d-block"
        id="exampleModal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title App-title" id="exampleModalLabel">
                {title}
              </h5>
              <button type="button" className="btn btn-secondary App-table-button-popup" onClick={closeclick}  data-dismiss="modal" aria-label="Close">
                <XSquare></XSquare>
              </button>
            </div>
            <div className="modal-body">
                <div className="App-scrollable">
                  {children}
                </div>
            </div>
          </div>
        </div>
      </div>
    );
  };